import { TicketingNotificationFilterTypes } from "@avenueops/frontend-shared";
import { ClientIntegration, CollectionsTicketingData, ManualNotificationType, TicketingData } from "@avenueops/shared-types";
import { SmartForm } from "@avenueops/web-components";
import CustomNotifications from "components/monitors/editFormReboot/CustomNotifications";
import CustomNotificationsAndSignals from "components/monitors/editFormReboot/CustomNotificationsAndSignals";
import { useFormContext, useWatch } from "react-hook-form";
import { getListRecipientValueOptions } from "utils/mergeTicketingUtils";

interface Props {
  notificationPrefix: string;
  disableCustomize?: boolean;
  trelloInstances: ClientIntegration[];
  mergeIntegrationData: {
    teams: TicketingData[];
    collections: CollectionsTicketingData[];
    users: TicketingData[];
    contacts: TicketingData[];
  };
}

export function TrelloNotificationInput({ notificationPrefix, disableCustomize, trelloInstances, mergeIntegrationData }: Props) {
  const { watch } = useFormContext();
  const notification: ManualNotificationType = useWatch({ name: notificationPrefix });
  const useMappingOverride = watch(`${notificationPrefix}.useMappingOverride`);
  const trelloRecipientOptions = getListRecipientValueOptions(trelloInstances);

  return (
    <>
      <div className="col-span-4">
        <SmartForm.DropdownSelect
          name={`${notificationPrefix}.integrationId`}
          defaultValue={trelloInstances.length === 1 ? trelloInstances[0].integrationId : undefined}
          title="Integration Instance"
          options={trelloInstances.map((integration) => ({
            label: integration.name ?? "Trello integration",
            value: integration.integrationId,
          }))}
        />
        <div className="pt-5">
          <SmartForm.DropdownSelect name={`${notificationPrefix}.recipientValue`} title="Project" options={trelloRecipientOptions} />
        </div>
      </div>
      {disableCustomize ? null : useMappingOverride ? (
        <div className="col-span-6">
          <CustomNotifications
            notificationPrefix={notificationPrefix}
            notificationType={notification.manualType}
            supportedTypes={TicketingNotificationFilterTypes}
          />
        </div>
      ) : (
        <div className="col-span-6">
          <CustomNotificationsAndSignals
            notificationPrefix={notificationPrefix}
            notificationType={notification.manualType}
            supportedTypes={TicketingNotificationFilterTypes}
          />
        </div>
      )}
    </>
  );
}
